import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import moment from "moment";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import {dashboardDataSelector, FetchDashboardData} from "./slice";
import Loader from "../../component/Loader";
import { cancelClass } from "../../api/class";
import { getTeacherId, getTeacherName } from "../../app/globalStore";
import { getCompanySubscription } from '../../api/subscription';

const style = {
  control: (styles) => ({
    ...styles,
    // none of react-select's styles are passed to <Control />
    borderWidth: 0,

    "&:hover": {
      borderColor: "transparent",
      outline: "0",
      boxShadow: "none",
    },
  }),
  container: (styles) => ({
    ...styles,
    // none of react-select's styles are passed to <Control />
    backgroundImage: "none",
    paddingRight: "2px",
    borderRadius: "10px",
  }),
};
function DashboardData() {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector(dashboardDataSelector);
  const subAdminData = useSelector((store) => store.subAdmin.detail);
  const authState = useSelector((store) => store.auth);
  const teacher_id = getTeacherId(); 
  const teacher_name = getTeacherName();
  const isSuperAdmin = authState?.user_type?.toLowerCase() === 'super_admin' || !subAdminData?.is_company;
  const [companySubscription, setCompanySubscription] = useState(null);
  const [loadingSubscription, setLoadingSubscription] = useState(false);
  
  // Check if company has no trial and no subscription
  const isInTrialPeriod = () => {
    if (!subAdminData?.trial_end) return false;
    const trialEndDate = new Date(subAdminData.trial_end);
    const currentDate = new Date();
    return currentDate <= trialEndDate;
  };

  const hasActiveSubscription = () => {
    // If in trial period, consider subscription active
    if (isInTrialPeriod()) return true;
    
    if (!companySubscription) return false;
    
    // Handle different possible status values
    const status = companySubscription.status?.toString().toLowerCase();
    console.log('Checking subscription status:', status); // Debug log
    
    // Consider subscription active if status is one of these values
    const activeStatuses = ['active', '1', 1, 'paid', 'subscribed', 'enabled', 'trial', 'trialing'];
    return activeStatuses.includes(status);
  };

  // Super admins always bypass subscription checks
  const hasNoTrialAndNoSubscription = !isSuperAdmin && !isInTrialPeriod() && !hasActiveSubscription(); 
  
  const [loading, setLoading] = useState(true);
  const [cancelClassModalShow, setCancelClassModalShow] = useState(false);
  
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  const [amount, setAmount] = useState({
    total: 0,
    netTotal: 0,
    adminEarning: 0,
  });
  const [dashboardData, setDashboardData] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState(null);
  const [availableDates, setAvailableDates] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching dashboard data...');
        setLoading(true);
        const result = await dispatch(FetchDashboardData({company_id:selectedCompany}));
        console.log('Dashboard data result:', result);
        if (result.error) {
          console.error('Error fetching data:', result.error);
          toast.error('Failed to load dashboard data', {  autoClose: false,  closeButton: true});
        }else{
          setDashboardData(result); // Store result in state
        }
      } catch (err) {
        console.error('Error in fetchData:', err);
        toast.error('Failed to load dashboard data', {  autoClose: false,  closeButton: true});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, selectedCompany]);

  // Fetch company subscription data
  useEffect(() => {
    const fetchCompanySubscriptionData = async () => {
      const companyId = subAdminData?.id || authState?.company_id;
      if (companyId) {
        setLoadingSubscription(true);
        try {
          const response = await getCompanySubscription(companyId);
          console.log('Dashboard - Subscription API Response:', response);
          
          if (response?.code === 1 && response?.data) {
            console.log('Dashboard - Subscription data:', response.data);
            setCompanySubscription(response.data);
          } else {
            console.log('Dashboard - No subscription data found:', response);
            setCompanySubscription(null);
          }
        } catch (error) {
          console.error('Dashboard - Error fetching company subscription:', error);
          setCompanySubscription(null);
        } finally {
          setLoadingSubscription(false);
        }
      }
    };

    fetchCompanySubscriptionData();
  }, [subAdminData?.id, authState?.company_id]);

  const handleCancelClassSelectChange = (selectedValue) => {
    console.log("Selected Class Time slot list:", selectedValue.time_slot_list);
    var times = selectedValue.time_slot_list
          ?.filter((it) => it?.isCancelled === false)
          ?.map((value) => {
            return {
              start_time: value?.start_time,
              end_time: value?.end_time,
              time_slot_id: value?.time_slot_id,
            };
          })
          ?.filter(
            (value, index, _arr) =>
              _arr.findIndex(
                (it) =>
                  it?.start_time === value.start_time &&
                  it?.end_time === value.end_time &&
                  it?.time_slot_id === value?.time_slot_id
              ) === index
          )
          .sort(function (a, b) {
            return (
              new Date(a.start_time) - new Date(b.start_time) &&
              new Date(a.end_time) - new Date(b.end_time)
            );
          });

        var days = selectedValue.time_slot_list
          ?.filter((it) => it?.isCancelled === false)
          ?.map((value) => {
            return { ...value, date: value.date };
          })
          ?.filter(
            (value, index, _arr) =>
              _arr.findIndex(
                (it) => it?.date?.toString() === value?.date?.toString()
              ) === index
          )
          ?.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date);
          });
          console.log('DATES----------', days)

          setAvailableTimeSlots(times);
          setAvailableDates(days);
  };

  const formik = useFormik({
    initialValues: {
      iTime: { start_time: "", end_time: "", time_slot_id: "" }, // Nested object initialized
      iDate: { date: "" }, // Ensure proper initialization
      selectedClass: null, // Null instead of empty string for Select component
      reason: ""
    },
    validationSchema: Yup.object({
      iTime: Yup.object({
        start_time: Yup.string().required("Start time is required"),
        end_time: Yup.string().required("End time is required"),
        time_slot_id: Yup.string().required("Time slot is required"),
      }),
      iDate: Yup.object({
        date: Yup.string().required("Date is required"),
      }),
      selectedClass: Yup.object().nullable().required("Class selection is required"),
      reason: Yup.string().required("Cancellation reason is required"),
    }),
    onSubmit: (values) => {
      console.log(values);
      if (values.selectedClass) {
        //alert("API calling...");
        cancelClass({
          classId: values.selectedClass.id,
          time_slot_id: values.iTime.time_slot_id,
          date: moment(values.iDate.date).format("YYYY-MM-DD"),
          cancel_reason: values.reason,
        }).then((res) => {
          if (res?.code === 1) {
            toast.success(res?.message);
            setCancelClassModalShow(false);
          } else {
            toast.error(res?.message, { autoClose: false, closeButton: true });
          }
        });
      } else {
        toast.error("Kindly select a class", { autoClose: false, closeButton: true });
      }
    },
  });
  

  if (loading || !data) {
    return (
      <article className="col-lg-9 articleClass">
        <div className="article-body store-bd-gy d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
          <Loader />
        </div>
      </article>
    );
  }
  
  // If company has no trial and no subscription, show welcome message only
  // Only show subscription message if profile is complete (is_profile_complete == 1 or is_basic_profile_complete == true)
  // Do not show message if trial has expired - only show when company has not yet started trial
  if (hasNoTrialAndNoSubscription && teacher_id <= 0) {
    const isProfileComplete = subAdminData?.is_profile_complete == 1;
    // Check if trial has expired (trial_end exists and is in the past)
    const trialEndDate = subAdminData?.trial_end ? new Date(subAdminData.trial_end) : null;
    const currentDate = new Date();
    const isTrialExpired = trialEndDate && currentDate > trialEndDate;
    
    return (
      <article className="col-lg-9 articleClass">
        <div className="article-body store-bd-gy d-flex justify-content-center align-items-center" style={{ minHeight: '80vh', flexDirection: 'column' }}>
          <div className="text-center">
            <div className="mb-4">
              <i className="fa fa-crown fa-4x text-warning"></i>
            </div>
            <h2 style={{ fontWeight: '600', marginBottom: '15px' }}>
              Welcome to BookInClass!
            </h2>
            {isProfileComplete && !isTrialExpired && (
              <>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', marginBottom: '20px' }}>
                  Thank you for signing up! To get started, please purchase a subscription or start your free trial to access all features.
                </p>
                <button 
                  className="btn btn-primary"
                  onClick={() => navigate('/subscription')}
                >
                  View Subscription Plans
                </button>
              </>
            )}
          </div>
        </div>
      </article>
    );
  }
  
  return (
    <article className="col-lg-9 articleClass">
  <div className="article-body store-bd-gy">
    {teacher_id <= 0 && (
      <h3 className="mb-4">ADMIN DASHBOARD</h3>
    )}
    {teacher_id > 0 && (
      <>
      <h2 style={{ fontWeight: '600', marginBottom: '10px' }}>
        Welcome, {teacher_name}!
      </h2>
      <p style={{ color: '#6b7280', fontSize: '1.1rem' }}>
        We're glad to have you on board.  
        This space is yours to manage your classes and inspire your students.
      </p>
      </>
    )}
    <div className="row mb-4">
    {Array.isArray(companyOptions) && companyOptions.length > 0 && (
      <div className="col-md-6 col-lg-3 mb-3">
        <Select
          options={companyOptions}
          isSearchable
          placeholder="Select a company..."
          defaultValue={companyOptions[selectedCompany]}
          onChange={option => {
            setSelectedCompany(option.value);
          }}
        />
      </div>
    )} 
    </div>  
    {/* Top Row Stats */}
    <div className="row mb-4">
      {/* Users Box */}
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Users</h5>
            <div className="d-flex justify-content-between">
              <span>New Users:</span>
              <span>{data.totalUser}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>New Students:</span>
              <span>{data.last7DaysStudents}</span>
            </div>
            {teacher_id <= 0 && (
            <div className="mt-auto">
              <button className="btn btn-success btn-sm" onClick={() => window.open('/users','_blank')}>MORE INFO</button>
            </div>
            )}
          </div>
        </div>
      </div>

      {/* Bookings Box */}
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Bookings</h5>
            <div className="d-flex justify-content-between">
              <span>Last 7 Days:</span>
              <span>{data.last7DaysBookings}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>This month so far:</span>
              <span>{data.currentMonthBookings}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Last Month:</span>
              <span>{data.lastMonthBookings}</span>
            </div>
            {teacher_id <= 0 && (
            <div className="mt-auto">
            <button className="btn btn-success btn-sm" onClick={() => window.open('/bookings','_blank')}>MORE INFO</button>
            </div>
            )}
          </div>
        </div>
      </div>

      {/* Income Box */}
      {teacher_id <= 0 && (
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Income</h5>
            <div className="d-flex justify-content-between">
              <span>Last 7 Days:</span>
              <span>£{data.last7DaysIncome}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>This month so far:</span>
              <span>£{data.currentMonthIncome}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Last Month:</span>
              <span>£{data.lastMonthIncome}</span>
            </div>
            <div className="mt-auto">
              <button className="btn btn-success btn-sm" onClick={() => window.open('/earnings-by-staff','_blank')}>MORE INFO</button>
            </div>
          </div>
        </div>
      </div>
      )}

      {/* Debtors Box */}
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Debtors</h5>
            <div className="d-flex justify-content-between">
              <span>Number of Users:</span>
              <span>{data.totalDebtors}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Amount of Debt:</span>
              <span>£{data.totalDebtorsAmount}</span>
            </div>
            {/* {teacher_id <= 0 && ( */}
            <div className="mt-auto">
              <button className="btn btn-success btn-sm" onClick={() => window.open('/debtors','_blank')}>MORE INFO</button>
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
    </div>

    {/* Middle Row */}
    
    <div className="row mb-4">
      {/* Earnings Box */}
      {teacher_id <= 0 && (
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Earnings this month</h5>
            {data.earning_list.map((earning, index) => (
              <div className="d-flex justify-content-between" key={index}>
                <span>{earning.teacher_details.full_name}:</span>
                <span>£{parseFloat(earning.total_amount).toFixed(2)}</span>
              </div>
            ))}
            <hr/>


            <div className="d-flex justify-content-between">
              <span>Total Income:</span>
              <span>
                £{data?.earning_list?.reduce((acc, item) => acc + Number(item.total_amount), 0).toFixed(2)}
              </span>
            </div>
            
            <div className="d-flex justify-content-between">
              <span>Admin Commission:</span>
              £{data?.admin_commision}
            </div>
            <div className="mt-auto">
              <button className="btn btn-success btn-sm" onClick={() => window.open('/finance','_blank')}>MORE INFO</button>
            </div>
          </div>
        </div>
      </div>
      )}

      {/* Memberships Box */}
      {teacher_id <= 0 && (
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Memberships Expiries</h5>
            <div className="d-flex justify-content-between">
              <span>Expired:</span>
              <span>{data.expired}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Expire in 7 days:</span>
              <span>{data.expireIn7days}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Expire in 30 days:</span>
              <span>{data.expireIn30days}</span>
            </div>
            <div className="d-none justify-content-between">
              <span>Inactive:</span>
              <span>{data.inactiveMemberships}</span>
            </div>
            <div className="mt-auto">
              <button className="btn btn-success btn-sm">MORE INFO</button>
            </div>
          </div>
        </div>
      </div>
      )}

      {/* Emergency Cancel Box */}
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">Emergency Class Cancel</h5>
            <p>Notify all with SMS and Email</p>
            <div className="mt-auto">
              <button className="btn btn-success" onClick={() => setCancelClassModalShow(true)}>CANCEL NOW</button>
            </div>
          </div>
        </div>
      </div>

      {/* Settings Box */}
      {teacher_id <= 0 && (
      <div className="col-md-6 col-lg-3 mb-3">
        <div className="card d-flex flex-column">
          <div className="card-body d-flex flex-column">
            <h5 className="card-title">SETTINGS</h5>
            <p>Edit Admin Settings</p>
            <div className="mt-auto">
              <button className="btn btn-success" onClick={() => window.open('/settings','_blank')}>GO TO</button>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
    

    {/* Events Table */}
    {teacher_id <= 0 && (
    <div className="card mb-4">
      <div className="card-body" style={{ overflowX: 'auto' }}>
        <h5 className="card-title">Next Events</h5>
        {data.upcommingEvents?.length > 0 ? (
          <table className="table-responsive">
            <thead>
              <tr>
                <th className="px-1">Date</th>
                <th className="px-3">Title</th>
                <th className="px-3">Venue name</th>
                <th className="px-3">Area</th>
                <th className="px-3">Time</th>
                <th className="px-3">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.upcommingEvents.map((event, index) => (
                <tr key={index}>
                  <td className="px-1">{moment(event.date).format('DD MMM YYYY')}</td>
                  <td className="px-3">{event.name}</td>
                  <td className="px-3">{event.school_details?.name}</td>
                  <td className="px-3">{event.areacode_details?.areacode}</td>
                  <td className="px-3">{event.start_time}</td>
                  <td className="px-3">
                    <button className="btn btn-success btn-sm" onClick={() => window.open(`/bookinclass-admin/event/${event.id}`, '_blank')}>
                      MORE INFO
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center">
            <p>No Upcoming Events!</p>
          </div>
        )}
      </div>
    </div>
    )}

    {/* Class Table */}
    {teacher_id <= 0 && (
    <div className="card mb-4">
      <div className="card-body" style={{ overflowX: 'auto' }}>
        <h5 className="card-title">Recent Class Additions</h5>
        {data.recentlyAddedClass?.length > 0 ? (
          <table className="table-responsive">
            <thead>
              <tr>
                <th className="px-5">Title</th>
                <th className="px-5">Venue name</th>
                <th className="px-5">Discipline</th>
                <th className="px-5">Ages</th>
                <th className="px-5">Area</th>
                <th className="px-5">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.recentlyAddedClass.map((classItem, index) => (
                <tr key={index}>
                  <td className="px-5">{classItem.name}</td>
                  <td className="px-5">{classItem.school_details?.name}</td>
                  <td className="px-5">{classItem.discipline_details?.name}</td>
                  <td className="px-5">{classItem.class_type}</td>
                  <td className="px-5">{classItem.areacode_details?.areacode}</td>
                  <td className="px-5">
                    <button 
                      className="btn btn-success btn-sm" 
                      onClick={() => window.open(`/bookinclass-admin/class-detail/${classItem.id}`, '_blank')}
                    >
                      MORE INFO
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center">
            <p>No Class Added Recently.</p>
          </div>
        )}
      </div>
    </div>
    )}
  </div>


  <Modal
        show={cancelClassModalShow}
        onHide={() => {
          setCancelClassModalShow(false);
        }}
        size="md"
        centered
      >
        <div className=" modal-dialog-centered">
        <div className="modal-content body-bg">
          <div className="modal-header border-0 justify-content-center">
            <h5>Cancel Class!</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setCancelClassModalShow(false);
              }}
            ></button>
          </div>
          <div className="modal-body mb-4 p-4">
            <form className="form-style" onSubmit={formik.handleSubmit}>
            <label className="fw-bold">Select Class For Cancellation</label> 

                <Select
                  options={data.classes || undefined}
                  getOptionLabel={(option) =>
                    option.name
                  }
                  getOptionValue={(option) => option?.id}
                  className="mb-4"
                  onChange={(val) => {
                    formik.setFieldValue("selectedClass", val);
                    handleCancelClassSelectChange(val);
                  }}
                  name="class_id"
                />
                 {formik.errors.selectedClass &&
                  formik.touched.selectedClass && (
                    <span className="text-danger">
                      {formik.errors.selectedClass}
                    </span>
                  )}

                <div className="d-flex gap-3">
                  <div className="form-group selectAreaCode">
                    <label className="fw-bold">Select Time</label>
                    <div className="input-container">

                      <Select
                        options={availableTimeSlots || undefined}
                        getOptionLabel={(option) =>
                          `${moment(option.start_time, "hh:mm:ss").format(
                            "hh:mm a"
                          )}-${moment(option?.end_time, "hh:mm:ss").format(
                            "hh:mm a"
                          )}`
                        }
                        styles={style}
                        getOptionValue={(option) => {
                          return {
                            start_time: option?.start_time,
                            end_time: option?.end_time,
                            time_slot_id: option?.time_slot_id,
                          };
                        }}
                        className="pl-5 form-select timeSelectWidth"
                        name="iTime"
                        onChange={(val) => {
                          formik.setFieldValue("iTime", val);
                        }}
                      />
                      <img
                        src="assets/images/event-name.png"
                        className="input-img inputImage"
                        alt=""
                      />
                    </div>
                    {formik.errors.iTime?.start_time && (
                      <span className="text-danger">
                        {formik.errors.iTime?.start_time}
                      </span>
                    )}
                  </div>
                  <div className="form-group selectAreaCode">
                    <label className="fw-bold">Select Date</label>

                    <div className="input-container">
                      <Select
                        styles={style}
                        options={availableDates || undefined}
                        getOptionLabel={(option) =>
                          `${moment(option.date).format("DD MMM YYYY")}`
                        }
                        getOptionValue={(option) => option}
                        className="pl-5 form-select timeSelectWidth"
                        onChange={(val) => {
                          formik.setFieldValue("iDate", val);
                        }}
                        name="iDate.date"
                      />
                      <img
                        src="assets/images/event-name.png"
                        className="input-img inputImage"
                        alt=""
                      />
                    </div>
                    {formik.errors.iDate?.date && (
                      <span className="text-danger">
                        {formik.errors.iDate?.date}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group gap-3">
                    <label className="fw-bold">Enter Cancellation  Reason</label>

                    <div className="input-container">
                    <textarea
                      style={style} // Use 'style' instead of 'styles'
                      name="reason"
                      rows="4"
                      value={formik.reason} // Ensure 'formik.values.reason' is used
                      placeholder="Enter your reason here..."
                      className="form-control"
                      onChange={(e) => {
                        formik.setFieldValue("reason", e.target.value); // Use 'e.target.value' to get the input value
                      }}
                    />

                    </div>
                    {formik.errors.reason && (
                      <span className="text-danger">
                        {formik.errors.reason}
                      </span>
                    )}
                  </div>
              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="btn btn-accept btn-view mt-2"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      </Modal>

</article>
  );
}

export default DashboardData;
